// import React, { useState, useRef, useEffect } from 'react';
// import { Link, useNavigate, useParams } from 'react-router-dom';
// import toast from 'react-hot-toast';
// import { Input, Render, Select } from '../../../components';
// import { VehicleService } from '../../../services';
// import { Constants, fromPhotos } from '../../../utils';

// const CreateVehicle = () => {
//   const fileInputRef = useRef(null);
//   const { form, imagenPreview, isLoading, isEdit, onChange, handleImageChange, removeImage, selects, handleUserSelect, submit } = useForm();

//   if (isLoading) {
//     return (
//       <div className="p-4">
//         <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-md p-8 flex items-center justify-center min-h-[400px]">
//           <div className="text-text font-medium">Cargando vehículo...</div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-4">
//       <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-md p-8">

//         <form onSubmit={submit} className="space-y-10">

//           <section>
//             <h2 className="text-lg font-bold mb-6 text-text">Información general</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

//               <div
//                 className="flex flex-col items-center justify-center border-2 border-dashed border-gray6 rounded-2xl p-8 bg-gray5 hover:bg-gray-100 transition-colors cursor-pointer min-h-[250px] relative overflow-hidden"
//                 onClick={() => fileInputRef.current?.click()}
//               >
//                 {imagenPreview ? (
//                   <>
//                     <img src={imagenPreview} alt="Vista previa" className="absolute inset-0 w-full h-full object-cover rounded-2xl" />
//                     <button
//                       type="button"
//                       className="absolute top-2 right-2 bg-white rounded-full p-1.5 shadow-md hover:bg-gray-100 transition-colors z-10"
//                       onClick={e => { e.stopPropagation(); removeImage(); }}
//                     >
//                       <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
//                         <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
//                       </svg>
//                     </button>
//                   </>
//                 ) : (
//                   <>
//                     <div className="bg-white p-4 rounded-full shadow-sm mb-4">
//                       <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 text-text">
//                         <path strokeLinecap="round" strokeLinejoin="round" d="M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z" />
//                       </svg>
//                     </div>
//                     <span className="text-text font-bold text-lg">Subir imagen</span>
//                     <span className="text-text text-sm mt-1">Formato: .jpg o jpeg</span>
//                     <span className="text-text text-xs">Mínimo 900x900px - Máximo 1080x1080px</span>
//                   </>
//                 )}
//                 <input
//                   type="file"
//                   accept=".jpg,.jpeg"
//                   ref={fileInputRef}
//                   onChange={handleImageChange}
//                   className="hidden"
//                 />
//               </div>

//               <div className="space-y-4">
//                 <div className="grid grid-cols-2 gap-4">
//                   <Input
//                     label="Placa *"
//                     placeholder="Ej: AS85PP"
//                     value={form.plaque}
//                     onValueChange={v => onChange(v, 'plaque')}
//                   />
//                   <Input
//                     label="Marca *"
//                     placeholder="Ej: Chevrolet"
//                     value={form.brand}
//                     onValueChange={v => onChange(v, 'brand')}
//                   />
//                 </div>
//                 <Input
//                   label="Modelo *"
//                   placeholder="Ej: Aveo"
//                   value={form.model}
//                   onValueChange={v => onChange(v, 'model')}
//                 />
//                 <div className="grid grid-cols-2 gap-4">
//                   <Input
//                     label="Año *"
//                     placeholder="Ej: 2007"
//                     value={form.year}
//                     onValueChange={v => onChange(v, 'year')}
//                   />
//                   <Input
//                     label="Color *"
//                     placeholder="Ej: Negro"
//                     value={form.color}
//                     onValueChange={v => onChange(v, 'color')}
//                   />
//                 </div>
//               </div>
//             </div>
//           </section>

//           <hr className="border-gray6" />

//           <section>
//             <h2 className="text-lg font-bold mb-6 text-text">Clasificación</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               <div className="space-y-1">
//                 <p className="text-sm font-bold text-text">Tipo de vehículo *</p>
//                 <Select
//                   placeholder="Seleccionar tipo"
//                   items={selects.types}
//                   value={form.vehicle_type_id}
//                   onValueChange={v => onChange(v, 'vehicle_type_id')}
//                 />
//               </div>
//               <div className="space-y-3">
//                 <p className="text-sm font-bold text-text">Aire acondicionado *</p>
//                 <div className="flex gap-6 items-center h-10">
//                   <label className="flex items-center gap-2 cursor-pointer">
//                     <input
//                       type="radio"
//                       name="aire"
//                       className="w-5 h-5 accent-[#22c55e]"
//                       checked={form.air_conditioning === '1'}
//                       onChange={() => onChange('1', 'air_conditioning')}
//                     />
//                     <span className="text-text font-medium">Sí</span>
//                   </label>
//                   <label className="flex items-center gap-2 cursor-pointer">
//                     <input
//                       type="radio"
//                       name="aire"
//                       className="w-5 h-5 accent-[#22c55e]"
//                       checked={form.air_conditioning === '0'}
//                       onChange={() => onChange('0', 'air_conditioning')}
//                     />
//                     <span className="text-text font-medium">No</span>
//                   </label>
//                 </div>
//               </div>
//             </div>
//           </section>

//           <hr className="border-gray6" />

//           <section>
//             <h2 className="text-lg font-bold mb-6 text-text">Propietario</h2>
//             <div className="space-y-6">
//               <div className="space-y-3">
//                 <p className="text-sm font-bold text-text">El vehículo pertenece a *</p>
//                 <div className="flex gap-8">
//                   <label className="flex items-center gap-2 cursor-pointer">
//                     <input
//                       type="radio"
//                       name="belongs_to"
//                       className="w-5 h-5 accent-[#22c55e]"
//                       checked={form.belongs_to === Constants.BELONGS_TO.MAXER}
//                       onChange={() => onChange(Constants.BELONGS_TO.MAXER, 'belongs_to')}
//                     />
//                     <span className="text-text font-medium">Maxer</span>
//                   </label>
//                   <label className="flex items-center gap-2 cursor-pointer">
//                     <input
//                       type="radio"
//                       name="belongs_to"
//                       className="w-5 h-5 accent-[#22c55e]"
//                       checked={form.belongs_to === Constants.BELONGS_TO.OWNER}
//                       onChange={() => onChange(Constants.BELONGS_TO.OWNER, 'belongs_to')}
//                     />
//                     <span className="text-text font-medium">Propietario</span>
//                   </label>
//                 </div>
//               </div>
//               <Render condition={form.belongs_to === Constants.BELONGS_TO.OWNER}>
//                 <div className="space-y-1">
//                   <p className="text-sm font-bold text-text">Propietario *</p>
//                   <UserSearch
//                     value={form.owner_id}
//                     driverName={form.owner_name}
//                     onSelect={handleUserSelect}
//                     placeholder="Buscar propietario..."
//                   />
//                   <p className="text-xs text-text mt-2">Seleccione el propietario al que pertenece este vehículo.</p>
//                 </div>
//               </Render>
//             </div>
//           </section>

//           <div className="flex justify-end gap-4">
//             <Link
//               to="/vehicles"
//               className="px-8 py-2 bg-white border border-gray6 text-text font-bold rounded-full hover:bg-gray5 transition-colors shadow-sm"
//             >
//               Cancelar
//             </Link>
//             <button
//               type="submit"
//               className="px-8 py-2 bg-[#22c55e] text-white font-bold rounded-full hover:bg-green transition-colors shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
//               disabled={isLoading}
//             >
//               {isLoading ? 'Guardando...' : (isEdit ? 'Actualizar vehículo' : 'Guardar vehículo')}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// const UserSearch = ({ value, driverName, onSelect, placeholder }) => {
//   const [query, setQuery] = useState('');
//   const [results, setResults] = useState([]);
//   const [isOpen, setIsOpen] = useState(false);
//   const [isSearching, setIsSearching] = useState(false);
//   const wrapperRef = useRef(null);
//   const debounceRef = useRef(null);

//   useEffect(() => {
//     if (value && driverName) {
//       setQuery(driverName);
//     } else if (!value) {
//       setQuery('');
//     }
//   }, [value, driverName]);

//   const searchUsers = async (search) => {
//     if (!search.trim()) {
//       setResults([]);
//       return;
//     }
//     setIsSearching(true);
//     try {
//       const response = await VehicleService.admin.findOwners({ search });
//       setResults(response.data || []);
//     } catch (error) {
//       setResults([]);
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const q = e.target.value;
//     setQuery(q);
//     setIsOpen(true);
//     if (debounceRef.current) clearTimeout(debounceRef.current);
//     debounceRef.current = setTimeout(() => searchUsers(q), 300);
//   };

//   const handleSelect = (user) => {
//     const name = `${user?.person?.name} ${user?.person?.lastname || ''}`.trim();
//     setQuery(name);
//     setIsOpen(false);
//     onSelect(user.id, name);
//   };

//   const handleClear = () => {
//     setQuery('');
//     onSelect('', '');
//     setIsOpen(false);
//   };

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   return (
//     <div className="relative" ref={wrapperRef}>
//       <div className="flex items-center gap-x-4 border border-gray6 bg-white h-10 w-full rounded-full px-5 py-3">
//         <input
//           type="text"
//           className="flex-1 outline-none border-none bg-transparent w-full text-sm"
//           placeholder={placeholder || 'Buscar propietario...'}
//           value={query}
//           onChange={handleInputChange}
//           onFocus={() => { if (results.length || query) setIsOpen(true); }}
//         />
//         {!!value && (
//           <button type="button" onClick={handleClear} className="p-0.5 rounded-full hover:bg-gray5 transition-colors">
//             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-text">
//               <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
//             </svg>
//           </button>
//         )}
//       </div>
//       {isOpen && (results.length > 0 || isSearching) && (
//         <div className="absolute z-20 mt-1 w-full bg-white border border-gray6 rounded-xl shadow-lg max-h-48 overflow-y-auto">
//           {isSearching ? (
//             <div className="px-4 py-3 text-sm text-default">Buscando...</div>
//           ) : (
//             results.map(user => (
//               <button
//                 key={user.id}
//                 type="button"
//                 className="w-full text-left px-4 py-2.5 text-sm text-text hover:bg-gray5 transition-colors first:rounded-t-xl last:rounded-b-xl"
//                 onClick={() => handleSelect(user)}
//               >
//                 {user?.person?.name} {user?.person?.lastname || ''}
//               </button>
//             ))
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// const useForm = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     plaque: '',
//     brand: '',
//     model: '',
//     year: '',
//     color: '',
//     vehicle_type_id: '',
//     air_conditioning: '0',
//     belongs_to: Constants.BELONGS_TO.MAXER,
//     owner_id: '',
//     owner_name: '',
//     driver_id: '',
//     driver_name: '',
//     photo: null,
//     hasFile: true,
//   });
//   const [selects, setSelects] = useState({
//     types: [],
//   });
//   const [imagenPreview, setImagenPreview] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   const isEdit = !!id;

//   const getSelects = async () => {
//     try {
//       const response = await VehicleService.admin.getSelects();
//       setSelects({
//         types: response.types?.map(x => ({ value: x.id, label: x.name })) || [],
//       });

//     } catch (error) {
//       setSelects([]);
//     }
//   }

//   const fillForm = async () => {
//     setIsLoading(true);
//     try {
//       const decodedId = atob(id);
//       const vehicle = await VehicleService.admin.findOne(decodedId);
//       setForm(s => ({
//         ...s,
//         id: vehicle.id,
//         plaque: vehicle.plaque,
//         brand: vehicle.brand,
//         model: vehicle.model,
//         year: vehicle.year,
//         color: vehicle.color,
//         vehicle_type_id: String(vehicle.vehicle_types?.at(0)?.VehicleVehicleType?.vehicle_type_id ?? ''),
//         air_conditioning: String(vehicle.conditions.air_conditioning ?? 0),
//         belongs_to: vehicle.belongs_to,
//         owner_id: vehicle.owner_id ?? '',
//         owner_name: vehicle.owner?.person ? vehicle.owner.person.fullName : '',
//         driver_id: vehicle.driver_id ?? '',
//         driver_name: vehicle.driver?.person ? vehicle.driver.person.fullName : '',
//         photo: vehicle.photo || null,
//         hasFile: true,
//       }));
//       if (vehicle.photo) setImagenPreview(fromPhotos(vehicle.photo));
//     } catch (error) {
//       toast.error('Error al cargar el vehículo');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const onChange = (value, target) => {
//     setForm(s => ({ ...s, [target]: value }));
//   };

//   const handleUserSelect = (id, name) => {
//     setForm(s => ({ ...s, owner_id: id, owner_name: name }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setForm(s => ({ ...s, photo: file }));
//     setImagenPreview(URL.createObjectURL(file));
//   };

//   const removeImage = () => {
//     setForm(s => ({ ...s, photo: null }));
//     setImagenPreview(null);
//   };

//   const isValidForm = () => {
//     const onError = (msg) => {
//       toast.error(msg);
//       return false;
//     };

//     if (!form.photo)
//       return onError('La foto es requerida');

//     if (!String(form.plaque).trim())
//       return onError('La placa es requerida');

//     if (!String(form.brand).trim())
//       return onError('La marca es requerida');

//     if (!String(form.model).trim())
//       return onError('El modelo es requerido');

//     if (!String(form.year).trim())
//       return onError('El año es requerido');

//     if (!String(form.color).trim())
//       return onError('El color es requerido');

//     if (!form.vehicle_type_id)
//       return onError('El tipo de vehículo es requerido');

//     if (form.belongs_to === Constants.BELONGS_TO.OWNER && !form.owner_id)
//       return onError('Seleccione un propietario');

//     return true;
//   };

//   const submit = async (e) => {
//     e.preventDefault();
//     if (!isValidForm()) return;
//     setIsLoading(true);
//     try {

//       const payload = {
//         ...form,
//         conditions: JSON.stringify({
//           air_conditioning: form.air_conditioning,
//         }),
//       };
//       isEdit
//         ? await VehicleService.admin.update(payload)
//         : await VehicleService.admin.create(payload);
//       toast.success(isEdit ? 'Vehículo actualizado con éxito' : 'Vehículo creado con éxito');
//       navigate('/vehicles');

//     } catch (error) {
//       console.log(error)
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     getSelects();
//     if (!id) return;

//     fillForm();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [id]);

//   return {
//     form,
//     imagenPreview,
//     isLoading,
//     isEdit,
//     onChange,
//     handleUserSelect,
//     handleImageChange,
//     removeImage,
//     selects,
//     submit,
//   };
// };

// export default CreateVehicle;

import React, {useState, useRef, useEffect} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import toast from "react-hot-toast";
import {Input, Render, Select} from "../../../components";
import {VehicleService} from "../../../services";
import {Constants, fromPhotos} from "../../../utils";

const CreateVehicle = () => {
  const fileInputRef = useRef(null);
  const {
    form,
    imagenPreview,
    isLoading,
    isEdit,
    onChange,
    handleImageChange,
    removeImage,
    selects,
    handleUserSelect,
    submit,
  } = useForm();

  if (isLoading)
    return (
      <div className="p-4">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-md p-8 flex items-center justify-center min-h-[400px]">
          <div className="text-text font-medium">Cargando vehículo...</div>
        </div>
      </div>
    );

  return (
    <div className="p-4">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-md p-8">
        <form onSubmit={submit} className="space-y-10">
          <section>
            <h2 className="text-lg font-bold mb-6 text-text">
              Información general
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* VISTA PREVIA IMAGEN - SIN CAMBIOS */}
              <div
                className="flex flex-col items-center justify-center border-2 border-dashed border-gray6 rounded-2xl p-8 bg-gray5 hover:bg-gray-100 transition-colors cursor-pointer min-h-[250px] relative overflow-hidden"
                onClick={() => fileInputRef.current?.click()}
              >
                {imagenPreview ? (
                  <>
                    <img
                      src={imagenPreview}
                      alt="Vista previa"
                      className="absolute inset-0 w-full h-full object-cover rounded-2xl"
                    />
                    <button
                      type="button"
                      className="absolute top-2 right-2 bg-white rounded-full p-1.5 shadow-md hover:bg-gray-100 transition-colors z-10"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeImage();
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-5 h-5 text-text"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18 18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </>
                ) : (
                  <>
                    <div className="bg-white p-4 rounded-full shadow-sm mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-10 h-10 text-text"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
                        />
                      </svg>
                    </div>
                    <span className="text-text font-bold text-lg">
                      Subir imagen
                    </span>
                  </>
                )}
                <input
                  type="file"
                  accept=".jpg,.jpeg"
                  ref={fileInputRef}
                  onChange={handleImageChange}
                  className="hidden"
                />
              </div>

              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <Input
                    label="Placa *"
                    placeholder="Ej: AS85PP"
                    value={form.plaque}
                    onValueChange={(v) => onChange(v, "plaque")}
                  />
                  <Input
                    label="Marca *"
                    placeholder="Ej: Chevrolet"
                    value={form.brand}
                    onValueChange={(v) => onChange(v, "brand")}
                  />
                </div>
                <Input
                  label="Modelo *"
                  placeholder="Ej: Aveo"
                  value={form.model}
                  onValueChange={(v) => onChange(v, "model")}
                />
                <div className="grid grid-cols-2 gap-4">
                  <Input
                    label="Año *"
                    placeholder="Ej: 2007"
                    value={form.year}
                    onValueChange={(v) => onChange(v, "year")}
                  />
                  <Input
                    label="Color *"
                    placeholder="Ej: Negro"
                    value={form.color}
                    onValueChange={(v) => onChange(v, "color")}
                  />
                </div>
              </div>
            </div>
          </section>

          <hr className="border-gray6" />

          {/* NUEVA SECCIÓN DE DOCUMENTOS / REQUISITOS */}
          <section>
            <h2 className="text-lg font-bold mb-6 text-text">
              Documentos y Requisitos
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <Input
                type="date"
                label="Vencimiento RCV *"
                value={form.rcv_expiration}
                onValueChange={(v) => onChange(v, "rcv_expiration")}
              />
              <Input
                label="Trimestres *"
                placeholder="Ej: 4to Trimestre 2026"
                value={form.quarters}
                onValueChange={(v) => onChange(v, "quarters")}
              />
            </div>
          </section>

          <hr className="border-gray6" />

          <section>
            <h2 className="text-lg font-bold mb-6 text-text">Clasificación</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-1">
                <p className="text-sm font-bold text-text">
                  Tipo de vehículo *
                </p>
                <Select
                  placeholder="Seleccionar tipo"
                  items={selects.types}
                  value={form.vehicle_type_id}
                  onValueChange={(v) => onChange(v, "vehicle_type_id")}
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-3">
                  <p className="text-sm font-bold text-text">
                    Aire acondicionado *
                  </p>
                  <div className="flex gap-6 items-center h-10">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="aire"
                        className="w-5 h-5 accent-[#22c55e]"
                        checked={form.air_conditioning === "1"}
                        onChange={() => onChange("1", "air_conditioning")}
                      />
                      <span className="text-text font-medium">Sí</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="aire"
                        className="w-5 h-5 accent-[#22c55e]"
                        checked={form.air_conditioning === "0"}
                        onChange={() => onChange("0", "air_conditioning")}
                      />
                      <span className="text-text font-medium">No</span>
                    </label>
                  </div>
                </div>

                {/* NUEVO RADIO PARA EXTINTOR */}
                <div className="space-y-3">
                  <p className="text-sm font-bold text-text">Extintor *</p>
                  <div className="flex gap-6 items-center h-10">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="extinguisher"
                        className="w-5 h-5 accent-[#22c55e]"
                        checked={form.extinguisher === "1"}
                        onChange={() => onChange("1", "extinguisher")}
                      />
                      <span className="text-text font-medium">Sí</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="extinguisher"
                        className="w-5 h-5 accent-[#22c55e]"
                        checked={form.extinguisher === "0"}
                        onChange={() => onChange("0", "extinguisher")}
                      />
                      <span className="text-text font-medium">No</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <hr className="border-gray6" />

          {/* SECCIÓN PROPIETARIO - SIN CAMBIOS */}
          <section>
            <h2 className="text-lg font-bold mb-6 text-text">Propietario</h2>
            <div className="space-y-6">
              <div className="space-y-3">
                <p className="text-sm font-bold text-text">
                  El vehículo pertenece a *
                </p>
                <div className="flex gap-8">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="belongs_to"
                      className="w-5 h-5 accent-[#22c55e]"
                      checked={form.belongs_to === Constants.BELONGS_TO.MAXER}
                      onChange={() =>
                        onChange(Constants.BELONGS_TO.MAXER, "belongs_to")
                      }
                    />
                    <span className="text-text font-medium">Maxer</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="belongs_to"
                      className="w-5 h-5 accent-[#22c55e]"
                      checked={form.belongs_to === Constants.BELONGS_TO.OWNER}
                      onChange={() =>
                        onChange(Constants.BELONGS_TO.OWNER, "belongs_to")
                      }
                    />
                    <span className="text-text font-medium">Propietario</span>
                  </label>
                </div>
              </div>
              <Render
                condition={form.belongs_to === Constants.BELONGS_TO.OWNER}
              >
                <div className="space-y-1">
                  <p className="text-sm font-bold text-text">Propietario *</p>
                  <UserSearch
                    value={form.owner_id}
                    driverName={form.owner_name}
                    onSelect={handleUserSelect}
                    placeholder="Buscar propietario..."
                  />
                </div>
              </Render>
            </div>
          </section>

          <div className="flex justify-end gap-4">
            <Link
              to="/vehicles"
              className="px-8 py-2 bg-white border border-gray6 text-text font-bold rounded-full hover:bg-gray5 transition-colors shadow-sm"
            >
              Cancelar
            </Link>
            <button
              type="submit"
              className="px-8 py-2 bg-[#22c55e] text-white font-bold rounded-full hover:bg-green transition-colors shadow-lg disabled:opacity-50"
              disabled={isLoading}
            >
              {isLoading
                ? "Guardando..."
                : isEdit
                  ? "Actualizar vehículo"
                  : "Guardar vehículo"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const UserSearch = ({value, driverName, onSelect, placeholder}) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const wrapperRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (value && driverName) {
      setQuery(driverName);
    } else if (!value) {
      setQuery("");
    }
  }, [value, driverName]);

  const searchUsers = async (search) => {
    if (!search.trim()) {
      setResults([]);
      return;
    }
    setIsSearching(true);
    try {
      const response = await VehicleService.admin.findOwners({search});
      setResults(response.data || []);
    } catch (error) {
      setResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleInputChange = (e) => {
    const q = e.target.value;
    setQuery(q);
    setIsOpen(true);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => searchUsers(q), 300);
  };

  const handleSelect = (user) => {
    const name = `${user?.person?.name} ${user?.person?.lastname || ""}`.trim();
    setQuery(name);
    setIsOpen(false);
    onSelect(user.id, name);
  };

  const handleClear = () => {
    setQuery("");
    onSelect("", "");
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={wrapperRef}>
      <div className="flex items-center gap-x-4 border border-gray6 bg-white h-10 w-full rounded-full px-5 py-3">
        <input
          type="text"
          className="flex-1 outline-none border-none bg-transparent w-full text-sm"
          placeholder={placeholder || "Buscar propietario..."}
          value={query}
          onChange={handleInputChange}
          onFocus={() => {
            if (results.length || query) setIsOpen(true);
          }}
        />
        {!!value && (
          <button
            type="button"
            onClick={handleClear}
            className="p-0.5 rounded-full hover:bg-gray5 transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 text-text"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
      {isOpen && (results.length > 0 || isSearching) && (
        <div className="absolute z-20 mt-1 w-full bg-white border border-gray6 rounded-xl shadow-lg max-h-48 overflow-y-auto">
          {isSearching ? (
            <div className="px-4 py-3 text-sm text-default">Buscando...</div>
          ) : (
            results.map((user) => (
              <button
                key={user.id}
                type="button"
                className="w-full text-left px-4 py-2.5 text-sm text-text hover:bg-gray5 transition-colors first:rounded-t-xl last:rounded-b-xl"
                onClick={() => handleSelect(user)}
              >
                {user?.person?.name} {user?.person?.lastname || ""}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
};

const useForm = () => {
  const {id} = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    plaque: "",
    brand: "",
    model: "",
    year: "",
    color: "",
    vehicle_type_id: "",
    air_conditioning: "0",
    extinguisher: "0", // NUEVO
    rcv_expiration: "", // NUEVO
    quarters: "", // NUEVO
    belongs_to: Constants.BELONGS_TO.MAXER,
    owner_id: "",
    owner_name: "",
    driver_id: "",
    driver_name: "",
    photo: null,
    hasFile: true,
  });
  const [selects, setSelects] = useState({types: []});
  const [imagenPreview, setImagenPreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const isEdit = !!id;

  const getSelects = async () => {
    try {
      const response = await VehicleService.admin.getSelects();
      setSelects({
        types: response.types?.map((x) => ({value: x.id, label: x.name})) || [],
      });
    } catch (error) {
      setSelects([]);
    }
  };

  const fillForm = async () => {
    setIsLoading(true);
    try {
      const decodedId = atob(id);
      const vehicle = await VehicleService.admin.findOne(decodedId);
      setForm((s) => ({
        ...s,
        id: vehicle.id,
        plaque: vehicle.plaque,
        brand: vehicle.brand,
        model: vehicle.model,
        year: vehicle.year,
        color: vehicle.color,
        rcv_expiration: vehicle.rcv_expiration || "", // NUEVO
        quarters: vehicle.quarters || "", // NUEVO
        vehicle_type_id: String(
          vehicle.vehicle_types?.at(0)?.VehicleVehicleType?.vehicle_type_id ??
            "",
        ),
        air_conditioning: String(vehicle.conditions?.air_conditioning ?? 0),
        extinguisher: String(vehicle.conditions?.extinguisher ?? 0), // NUEVO
        belongs_to: vehicle.belongs_to,
        owner_id: vehicle.owner_id ?? "",
        owner_name: vehicle.owner?.person ? vehicle.owner.person.fullName : "",
        driver_id: vehicle.driver_id ?? "",
        driver_name: vehicle.driver?.person
          ? vehicle.driver.person.fullName
          : "",
        photo: vehicle.photo || null,
        hasFile: true,
      }));
      if (vehicle.photo) setImagenPreview(fromPhotos(vehicle.photo));
    } catch (error) {
      toast.error("Error al cargar el vehículo");
    } finally {
      setIsLoading(false);
    }
  };

  const onChange = (value, target) => setForm((s) => ({...s, [target]: value}));
  const handleUserSelect = (id, name) =>
    setForm((s) => ({...s, owner_id: id, owner_name: name}));

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setForm((s) => ({...s, photo: file}));
    setImagenPreview(URL.createObjectURL(file));
  };

  const removeImage = () => {
    setForm((s) => ({...s, photo: null}));
    setImagenPreview(null);
  };

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    };
    if (!form.photo) return onError("La foto es requerida");
    if (!String(form.plaque).trim()) return onError("La placa es requerida");
    if (!String(form.brand).trim()) return onError("La marca es requerida");
    if (!String(form.model).trim()) return onError("El modelo es requerido");
    if (!String(form.year).trim()) return onError("El año es requerido");
    if (!String(form.color).trim()) return onError("El color es requerido");
    if (!form.rcv_expiration) return onError("La fecha RCV es requerida"); // NUEVO
    if (!String(form.quarters).trim())
      return onError("Los trimestres son requeridos"); // NUEVO
    if (!form.vehicle_type_id)
      return onError("El tipo de vehículo es requerido");
    if (form.belongs_to === Constants.BELONGS_TO.OWNER && !form.owner_id)
      return onError("Seleccione un propietario");
    return true;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!isValidForm()) return;
    setIsLoading(true);
    try {
      const payload = {
        ...form,
        conditions: JSON.stringify({
          air_conditioning: form.air_conditioning,
          extinguisher: form.extinguisher, // NUEVO
        }),
      };
      isEdit
        ? await VehicleService.admin.update(payload)
        : await VehicleService.admin.create(payload);
      toast.success(
        isEdit ? "Vehículo actualizado con éxito" : "Vehículo creado con éxito",
      );
      navigate("/vehicles");
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSelects();
    if (id) fillForm();
  }, [id]);

  return {
    form,
    imagenPreview,
    isLoading,
    isEdit,
    onChange,
    handleUserSelect,
    handleImageChange,
    removeImage,
    selects,
    submit,
  };
};

export default CreateVehicle;
